// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm} from 'redux-form'
import {FormGroup, InputField} from '../../form'
import {NavLink} from 'react-router-dom'

import {forgotPassword} from '../../../actions/user'

import {VerimatrixLogo} from '../../../media/exports'
import ErrorIcon from '@material-ui/icons/Error'

import './index.css'
import ResetPasswordForm from './ResetPasswordForm'

class ResetPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      'showResetPasswordForm': false
    }
  }

  renderSuccessMessage = () => {
    return (
      <div className='container col-md-4 col-md-offset-4'>
        <div className='reset-password-success-message'>
          {<img src={VerimatrixLogo} alt='Verimatrix Logo' className='vmx-logo'/>}
          <div className='succes-message-fields'>
            <label className='lblResetPassword'>Reset your password</label>
            <div className='reset-password-success-div row'>
              <div className='reset-password-success-text col-12'>
                  An email with instructions to reset your password has been sent to the email address you have registered with Verimatrix.
              </div>
            </div>

            <div className='buttons row'>
              <div className='col-6'>
                <button className='btn btn-accept' onClick={() => {this.setState({showResetPasswordForm: true})}}>OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    const {error, invalid, handleSubmit, submitSucceeded, submitFailed, submitting} = this.props

    if (this.state.showResetPasswordForm) {
      return (
        <ResetPasswordForm/>
      )
    }

    if (!submitting && submitSucceeded && !submitFailed) {
      return this.renderSuccessMessage()
    }

    return (
      <>
        <div className='container col-lg-4 col-md-6 col-7'>
          <form className='form reset-password-form' onSubmit={handleSubmit}>
            {<img src={VerimatrixLogo} alt='Verimatrix Logo' className='vmx-logo'/>}
            <div className='reset-password-fields'>
              <label className='lblResetPassword'>Reset your password</label>
              <div className='reset-password-div row'>
                <div className='reset-password-text col-12'>
                If you have created an account online before but cannot remember your password, enter your email address so we can reset your credentials.
                </div>
              </div>
              <div className='inputs'>
                <FormGroup labelText='Email'>
                  <Field
                    name='username'
                    type='email'
                    placeholder='Enter email address'
                    component={InputField}
                  />
                </FormGroup>
              </div>
              {error &&
            <div className='error'>
              <ErrorIcon/>{` ${error}`}
            </div>
              }
              <FormGroup>
                <div className='buttons row'>
                  <div className='col-6'>
                    <button className='btn btn-accept' type='submit' disabled={invalid}>Continue</button>
                  </div>
                  <div className='col-6'>
                    <NavLink className='btn btn-cancel' to={`/`}>Cancel</NavLink>
                  </div>
                </div>
              </FormGroup>
            </div>
          </form>
        </div>
      </>
    )
  }
}

function mapStateToProps ({spinner}) {
  return {spinner}
}

function onSubmit (values, dispatch) {
  dispatch(forgotPassword(values))
}

function validate (values) {
  let ret = {}

  if (!values.username || !values.username.trim()) {
    ret = {...ret, username: 'Email cannot be blank'}
  }

  return ret
}

const resetPasswordRedux = connect(mapStateToProps)(ResetPassword)

export default reduxForm({
  form: 'resetPassword',
  onSubmit: onSubmit,
  validate: validate
})(resetPasswordRedux)
